import * as angular from "angular";
import {IController, ITimeoutService, IWindowService} from "angular";
import * as _ from "lodash";
import {GlobalSearchItemsType} from "../../modules/search/types/global-search-items.type";
import {ThreePLProviderType} from "../../modules/threePL/types/threePL-provider.type";
import {SplitService} from "../../modules/commons/services/split-service.service";
import {DeliveriesAlertsService} from "../../modules/deliveries/services/deliveries-alerts.service";
import {DeliveriesDialogService} from "../../modules/deliveries/services/deliveries-dialog-service.service";
import {ViewsStateType} from "../../modules/commons/types/views-state.type";
import {
  ViewSettingsHolderType,
  ViewSettingsModel,
  ViewSettingsType
} from "../../modules/commons/models/view-settings.model";
import {ViewSettingsService} from "../../modules/commons/services/view-settings-service.service";
import {EnvironmentType} from "../../modules/commons/types/environment.type";
import {OmsDialogService} from "../../modules/oms/services/oms-dialog-service.service";
import {OmsOrdersAlertsService} from "../../modules/oms/services/oms-orders-alerts.service";

export class TopNavSiteComponent implements IController {

  resource: any;
  siteId: any;
  chatHasUnreadMessages?: boolean;
  isBreadcrumbsEnabled?: boolean;
  isSiteNavMenuEnabled?: boolean;
  chatUnreadMessagesCount?: number;
  defaultHomePageSettings: ViewSettingsModel;
  loading?: boolean;

  public environmentTypes: typeof EnvironmentType = EnvironmentType;
  public environment: EnvironmentType;

  private breadcrumbs: any;
  private hiddenCrumbs: any;
  private isLongBreadcrumbs: any;
  private isFullScreen: any;
  private currentUser: any;
  private online: any;
  private parentToolbar: any;
  public logoUrl: any;
  public expirationByPolicy: { policyId, expireAt }
  public isBigScreen: any;
  public isTrainProviderActive: boolean;
  public viewsStateTypes: typeof ViewsStateType = ViewsStateType;
  public isMobileScreen: boolean;

  /* @ngInject */
  constructor(private UserService, private $mdMedia, private $state, private $mdUtil,
              private splitService: SplitService, private $log, private deliveriesAlertsService: DeliveriesAlertsService,
              private $mdSidenav, private triBreadcrumbsService, private deliveriesConstants, private apiConfig,
              private deliveriesDialogService: DeliveriesDialogService, private $window: IWindowService, private $timeout: ITimeoutService,
              private $element, private IAMPermissions, private viewSettingsService: ViewSettingsService,
              private omsDialogService: OmsDialogService, private omsOrdersAlertsService: OmsOrdersAlertsService) {
    this.breadcrumbs = triBreadcrumbsService.breadcrumbs;
    this.hiddenCrumbs = triBreadcrumbsService.hiddenCrumbs;
  }

  $onInit() {
    this.environment = this.apiConfig.env;

    this.isLongBreadcrumbs = false;
    this.isFullScreen = false;
    this.currentUser = this.UserService.getCurrentUser();
    this.online = true;
    this.parentToolbar = this.$mdUtil.getClosest(this.$element, 'MD-TOOLBAR');

    if (this.siteId) {
      this.logoUrl = this.splitService.getSiteLogoUrl();

      const memberPermissions = this.splitService.getMemberPermissions();
      this.expirationByPolicy = memberPermissions?.expirationByPolicies ?
        memberPermissions.expirationByPolicies[0] :
        undefined;
    }

    const supportedThreePLProviders = this.splitService.getSupportedThreePlProviders();
    this.isTrainProviderActive = _.find(supportedThreePLProviders, (providerKey) => {
      return providerKey === ThreePLProviderType.TrainIL;
    });

    this.$window.addEventListener("offline", () => {
      this.$timeout(() => {
        this.online = false;
      }, 0)
    }, false);

    this.$window.addEventListener("online", () => {
      this.$timeout(() => {
        this.online = true;
      }, 0)
    }, false);

  }

  $doCheck() {
    this.isBigScreen = this.$mdMedia('gt-md');
    this.isMobileScreen = !this.$mdMedia('gt-xs');
    this.checkIsLongBreadcrumbs();
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  openSideNav(navID) {
    this.$mdUtil.debounce(() => {
      this.$mdSidenav(navID).toggle();
    }, 300)();
  }

  onNavigateToDefaultHomePage() {
    const defaultHomePageView = this.viewsStateTypes[this.defaultHomePageSettings?.pageName];

    if (!!defaultHomePageView &&
      (!defaultHomePageView.permission || this.IAMPermissions.hasPermission(defaultHomePageView.permission))) {
      this.$state.go(defaultHomePageView.state);
    }
  }

  onChangeDefaultHomePage(key) {
    if (this.defaultHomePageSettings) {
      const defaultHomePageSettingsCopy = {...this.defaultHomePageSettings, pageName: key}
      this.viewSettingsService.updateByUser(defaultHomePageSettingsCopy.id, defaultHomePageSettingsCopy)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.defaultHomePageSettings = viewSettingsTable;
        })
    } else {
      const viewTableSettings = {
        pageName: key,
        holderType: ViewSettingsHolderType.User,
        settingsType: ViewSettingsType.HomePage
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.defaultHomePageSettings = viewSettingsTable
        })
      if (!!this.defaultHomePageSettings?.settings.value && this.IAMPermissions.hasPermission(this.viewsStateTypes[this.defaultHomePageSettings?.settings.value].permission)) {
        this.$state.go(this.viewsStateTypes[this.defaultHomePageSettings?.settings.value].state);
      }
    }
  }

  changeStateFromCrumb(crumb) {
    if (!_.isUndefined(crumb.state)) {
      this.$state.go(crumb.state, crumb.params);
    }
  }

  toggleNotificationsTab(tab) {
    this.openSideNav('notifications');
  }

  onSelectDeliveryCreationType(account, event, isOperation) {
    const creationPromise = isOperation
      ? this.deliveriesDialogService.createSimpleOperation(event, account)
      : this.deliveriesDialogService.createSimple(event, account);

    const redirectType = isOperation
      ? this.deliveriesConstants.redirectLinkByTextTriggerGroup.Operation
      : this.deliveriesConstants.redirectLinkByTextTriggerGroup.Delivery;

    creationPromise
      .then((order) => {
        this.deliveriesAlertsService.createDeliverySuccess(order.serviceList[0], true)
          .then((res) => {
            if (res) {
              this.$state.go(redirectType, {
                id: order.serviceIdList[0]
              });
            }
          });
      })
      .catch((error) => {
        if (error) {
          this.deliveriesAlertsService.createDeliveryError()
        } else {
          this.$log.info('Dialog Closed');
        }
      });
  }

  onCreateOmsOrder(account) {
    this.omsDialogService.createBasicOrder(account)
      .then(({order, isDraft}) => {
        this.omsOrdersAlertsService.createSuccessWithView(order, isDraft)
          .then((res) => {
            if (res) {
              this.$state.go('order.info', {id: order.id});
            }
          });
      })
      .catch((data) => {
        if (data?.isAdvanced) {
          this.$state.go('order-create', {order: data.order, isPrefilled: true});
        } else {
          this.$log.info('Dialog Closed');
        }
      });
  }

  onSubMenuSelect() {
    this.parentToolbar.classList.remove('md-has-open-menu');
  }

  showAllCrumbs() {
    this.triBreadcrumbsService.showHiddenCrumbs();
  }

  // function toggleFullScreen() {
  //     ctrl.isFullScreen = !ctrl.isFullScreen;
  //     // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
  //     var doc = $document[0];
  //     if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement ) {
  //         if (doc.documentElement.requestFullscreen) {
  //             doc.documentElement.requestFullscreen();
  //         } else if (doc.documentElement.msRequestFullscreen) {
  //             doc.documentElement.msRequestFullscreen();
  //         } else if (doc.documentElement.mozRequestFullScreen) {
  //             doc.documentElement.mozRequestFullScreen();
  //         } else if (doc.documentElement.webkitRequestFullscreen) {
  //             doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
  //         }
  //     } else {
  //         if (doc.exitFullscreen) {
  //             doc.exitFullscreen();
  //         } else if (doc.msExitFullscreen) {
  //             doc.msExitFullscreen();
  //         } else if (doc.mozCancelFullScreen) {
  //             doc.mozCancelFullScreen();
  //         } else if (doc.webkitExitFullscreen) {
  //             doc.webkitExitFullscreen();
  //         }
  //     }
  // }

  onGlobalSearchSelect(item, type: GlobalSearchItemsType) {
    const params = {
      siteId: this.splitService.getSiteId(),
      id: item.id
    };
    switch (type) {
      case GlobalSearchItemsType.Services: {
        this.$state.go(this.deliveriesConstants.redirectLinkByTextTriggerGroup[item.serviceType], params);
        break;
      }
      case GlobalSearchItemsType.Orders: {
        this.$state.go('order.info', params);
        break;
      }
      case GlobalSearchItemsType.Attempts: {
        if (item.subType === 'ThirdParty') {
          this.$state.go('threePLService.info', params);
        } else {
          this.$state.go(this.deliveriesConstants.redirectLinkByTextTriggerGroup[item.serviceType], params);
        }
        break;
      }
    }
  }

  private checkIsLongBreadcrumbs() {
    this.isLongBreadcrumbs = _.find(this.breadcrumbs.crumbs, (b) => {
      return b.isHidden;
    });
  }


}

angular
  .module('bringoz.admin.commons')
  .component('topNavSite', {
    bindings: {
      resource: '<',
      defaultHomePageSettings: '<?',
      isBreadcrumbsEnabled: '<?',
      isSiteNavMenuEnabled: '<?',
      siteId: '<?',
      chatHasUnreadMessages: '<?',
      chatUnreadMessagesCount: '<?',
      loading: '<?'
    },
    /* @ngInject */
    template: require('./top-nav-site.html').default,
    controller: TopNavSiteComponent
  });
